import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./pages/HomePage";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const ParticipantPortal = lazy(() => import("./pages/ParticipantPortal"));
const VerifyInvitation = lazy(() => import("./pages/VerifyInvitation"));

const RouteLoader = () => (
  <div className="route-loader" role="status" aria-live="polite">
    <span className="route-loader__dot" />
    <span>Cargando módulo…</span>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<RouteLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/portal" element={<ParticipantPortal />} />
            <Route path="/portal/:section" element={<ParticipantPortal />} />
            <Route path="/verificar/:code" element={<VerifyInvitation />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </Suspense>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
